<template>
  <v-menu top left offset-y content-class="contact-portal-link-copy">
    <template v-slot:activator="{ on }">
      <v-btn color="appMain" v-on="on">
        {{ copied ? 'Copied!' : 'Copy' }}
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, index) in linksDropdown"
        :key="index"
        v-clipboard="() => item.link"
        @click="onLinkCopy(item.link)"
      >
        <v-list-item-title>
          {{ item.text }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import Vue from 'vue';
import Clipboard from 'v-clipboard';
Vue.use(Clipboard);

export default {
  name: 'ContactPortalLinkCopy',
  props: {
    copyLink: String,
    contactName: String,
    pid: String,
  },
  data() {
    return {
      copied: null,
    };
  },
  computed: {
    genericCopyLink() {
      if (!this.copyLink) return;
      return this.copyLink.replace(`/${this.pid}`, '');
    },

    linksDropdown() {
      return [
        {
          text: `${this.contactName}'s Link`,
          link: this.copyLink,
        },
        {
          text: 'Universal Link',
          link: this.genericCopyLink,
        },
      ];
    },
  },
  methods: {
    onLinkCopy() {
      this.copied = true;

      setTimeout(() => {
        this.copied = false;
      }, 1000);
    },
  },
};
</script>

<style>
.contact-portal-link-copy {
  margin-top: -4px;
}
</style>
